import React, { useState, useEffect } from 'react';
import Home from './Home';
import About from './About';
import Projects from './Projects';
import Reviews from './Reviews';
import Contact from './Contact';
import Footer from './Footer';
import { Analytics } from "@vercel/analytics/react"
import './App.css';

function App() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="app">
      <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
        <div className="logo">
          <img src="/logo/logo.png" alt="לוגו בינה" className="navbar-logo" />
          <span className="logo-text">בינה לבנייה</span>
        </div>
        <ul>
          <li><button onClick={() => scrollToSection('home')}>ראשי</button></li>
          <li><button onClick={() => scrollToSection('about')}>אודות</button></li>
          <li><button onClick={() => scrollToSection('projects')}>פרויקטים</button></li>
          <li><button onClick={() => scrollToSection('reviews')}>חוות דעת</button></li>
          <li><button onClick={() => scrollToSection('contact')} className="cta-nav">צור קשר</button></li>
        </ul>
      </nav>

      <main>
        <section id="home">
          <Home />
        </section>
        <section id="about">
          <About />
        </section>
        <section id="projects">
          <Projects />
        </section>
        <section id="reviews">
          <Reviews />
        </section>
        <section id="contact">
          <Contact />
        </section>
      </main>

      <Footer />
      <Analytics />
    </div>
  );
}

export default App;
